import styled from 'styled-components';

export const ScBadges = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  top: -4px;
  left: -4px;
  pointer-events: none;

  & .new {
    order: -1;
  }
`;
